module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box box-25 has-loading"
  }, [_c('app-content-loader', {
    attrs: {
      "is-loading": _vm.carregandoDados
    },
    on: {
      "update:isLoading": function($event) {
        _vm.carregandoDados = $event
      },
      "update:is-loading": function($event) {
        _vm.carregandoDados = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "box-header"
  }, [_c('div', {
    staticClass: "box-title"
  }, [_vm._v("Novidades")]), _vm._v(" "), _c('div', {
    staticClass: "box-nav"
  }, [_c('div', {
    staticClass: "box-icon",
    attrs: {
      "title": "Recarregar Dados"
    },
    on: {
      "click": function($event) {
        return _vm.buscarNovidades()
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-sync"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "box-content"
  }, [(!_vm.conteudoDisponivel) ? _c('div', {
    staticClass: "box-content-vazio -menor"
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), (_vm.conteudoDisponivel) ? _c('ul', {
    staticClass: "news"
  }, _vm._l((_vm.novidades), function(item) {
    return _c('li', {
      on: {
        "click": function($event) {
          return _vm.mostrarNoticia(item)
        }
      }
    }, [(item.imagem) ? _c('figure', {
      staticClass: "news-image"
    }, [_c('img', {
      attrs: {
        "src": item.imagem,
        "alt": ""
      }
    })]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "data"
    }, [_c('h4', {
      staticClass: "news-title"
    }, [_vm._v(_vm._s(item.titulo))]), _vm._v(" "), _c('div', {
      staticClass: "news-datetime"
    }, [_vm._v("Atualizado em " + _vm._s(_vm._f("dateTimeEnToBr")(item.atualizado_em)))])])])
  }), 0) : _vm._e()]), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": "80%"
    },
    model: {
      value: (_vm.mostrarModal),
      callback: function($$v) {
        _vm.mostrarModal = $$v
      },
      expression: "mostrarModal"
    }
  }, [_c('v-card', {
    staticClass: "modal-noticia"
  }, [_c('v-card-title', {
    staticClass: "primary white--text"
  }, [_vm._v("\n                " + _vm._s(_vm.noticia.titulo) + "\n            ")]), _vm._v(" "), _c('v-card-text', [_c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [(_vm.noticia.imagem) ? _c('v-flex', {
    attrs: {
      "sm4": "",
      "xs12": ""
    }
  }, [_c('figure', {
    staticClass: "imagem"
  }, [_c('img', {
    attrs: {
      "src": _vm.noticia.imagem,
      "alt": ""
    }
  })])]) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "sm8": "",
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "modal-noticia-texto",
    domProps: {
      "innerHTML": _vm._s(_vm.noticia.texto)
    }
  })])], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.mostrarModal = false
      }
    }
  }, [_vm._v("\n                    Fechar\n                ")])], 1)], 1)], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "icon-vazio"
  }, [_c('i', {
    staticClass: "fas fa-newspaper"
  }), _vm._v(" "), _c('i', {
    staticClass: "fas fa-grin-beam-sweat"
  })]), _vm._v(" "), _c('h3', [_vm._v("Novidades não disponíveis")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2959ae6e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/domains/dashboard/Novidades.vue
// module id = 528
// module chunks = 2